{
	"description": "Description",
	"descriptionPlaceholder": "Register content description of the shipment",
	"sendAFile": "Send a file/files",
	"validReceipt": "The invoice needs to contain product description, total price and delivery/shipping fee.",
	"nextStep": "Next step",
	"prevStep": "< previous",
	"prevStepMobile": "< Previous",
	"submit": "Send request",
	"confirm": "Confirm",
	"close": "Close",
	"contentDescription": "Content description",
	"trackingNumbers": {
		"enter": "Enter only one tracking number at a time",
		"addButton": "Add",
		"errors": {
			"trackingnumber-min": "At least 1 tracking number",
			"validation": "Error with tracking number"
		}
	},
	"recipient": {
		"noIcelandicSocialId": "I do not have an Icelandic social ID",
		"name": "Name",
		"namePlaceholder": "Name of recipient",
		"socialId": "Social ID of recipient",
		"socialIdPlaceholder": "Social ID of recipient",
		"email": "Email",
		"emailPlaceholder": "Email of recipient",
		"phone": "Mobile phone",
		"phonePlaceholder": "Mobile phone of recipient",
		"errors": {
			"required": "Field is required",
			"name-invalid": "Invalid name",
			"phone-invalid": "Invalid phone number",
			"phone-max": "Max 7 digits",
			"phone-min": "At least 7 digits",
			"email-invalid": "Invalid email address",
			"ssn-min": "At least 10 digits",
			"ssn-valid": "Social ID is not valid"
		}
	},
	"shipment": {
		"hasInvoice": "I have the invoice",
		"openUp": "I don't have the invoice. I want Pósturinn to open my shipment and look for the invoice (price 990 kr.)",
		"alreadyCleared": "This shipment has already been cleared by customs with another shipment",
		"gift": "The shipment is a gift",
		"other": "None of the above",
		"errors": {
			"required": "Please select one of the above",
			"file-min": "At least 1 file"
		}
	},
	"openUp": {
		"option1": "I want my shipment to be opened and checked by Pósturinn before cleared by customs. (990 kr.)",
		"option2": "I want the shipment to be opened (990 kr.) and cleared by customs according to Pósturinn ",
		"termsLink": "https://posturinn.is/media/ysbcfhwx/terms_custom.pdf",
		"terms": "terms"
	},
	"alreadyCleared": {
		"shipmentClearedText": "Enter the tracking number on the shipment that has already been cleared by customs. Send us further information regarding the shipment and the invoice for the whole order. ",
		"shipmentClearedTrackingNumber": "Tracking number on the shipment that was cleared by customs",
		"shipmentClearedTrackingNumberPlaceholder": "Enter the tracking number",
		"errors": {
			"required": "Field is required",
			"invalid-cleared-tracking-number": "Invalid tracking number",
			"file-min": "At least 1 file"
		}
	},
	"gift": {
		"explanation": "In certain cases, you don't have to pay fees on gifts sent to the country e.g. if the value of the gift is not more then 13.500 ISK.",
		"selectText": "Type of gift",
		"selectPlaceholder": "Select",
		"furtherInfo": "Further information from Skatturinn about ",
		"furtherInfoLinkText": "gifts",
		"furtherInfoUrl": "https://www.skatturinn.is/english/individuals/customs-matters/travelling-to-iceland/gifts/",
		"giftType": {
			"birthday": "Birthday present",
			"graduation": "Graduation present",
			"confirmationOrBaptise": "Confirmation or baptise present",
			"wedding": "Wedding present",
			"christmas": "Christmas present",
			"other": "None of the above"
		}
	},
	"delivery": {
		"explanation": "If you submit the request before 11:30 you can request express handling and the shipment will be delivered the same day to the post office or your home in the capital area. Otherwise, it will be processed according to the default. Payment for express service is made upon delivery."
	},
	"terms": {
		"explanation": "By filling out this request you grant Pósturinn permission to clear your shipment through Customs. ",
		"agreeText": "I agree with these ",
		"termsLinkText": "terms",
		"termsLinkUrl": "https://posturinn.is/media/ysbcfhwx/terms_custom.pdf"
	},
	"received": {
		"success": "Request received",
		"successText": "Thank you. If more details are required, we will get in touch with you. When your shipment is ready for delivery, you will be notified."
	},
	"formStepTitles": {
		"trackingNumbers": "1. Enter tracking number",
		"recipient": "2. Recipient",
		"shipment": "3. The Shipment",
		"type": {
			"hasInvoice": "4. Send an invoice",
			"openUp": "4. Open shipment",
			"alreadyCleared": "4. Shipment cleared by customs",
			"gift": "4. A Gift",
			"other": "4. Send us information"
		},
		"delivery": "5. Same day delivery in the capital area?",
		"terms": "Terms"
	},
	"inactiveTitles": {
		"trackingNumbers": "1. Tracking number",
		"recipient": "2. Recipient",
		"shipment": "3. The Shipment",
		"type": {
			"hasInvoice": "4. Invoice",
			"openUp": "4. Open shipment",
			"alreadyCleared": "4. Shipment cleared by customs",
			"gift": "4. A Gift",
			"other": "4. Information"
		},
		"delivery": "5. Same day delivery",
		"terms": "Terms"
	}
}